/**
 * Returns the container base path (e.g. `/grootzakelijk`, `/pr-123/mijn-eneco`)
 * by reading from the same environment variables used by `next.config.js`.
 *
 * This avoids relying on Next.js internal request metadata (`initURL`, `req.url`)
 * which broke across the Next.js 15 → 16 migration due to changes in how
 * `req.url` is rewritten for `_next/data` requests.
 *
 * Source of truth: `config/next/config.js` → `getBasePath(process.env.PROJECT_BASEPATH)`
 */
export const getContainerBasePath = (): string => {
  const hostedPr = process.env.HOSTED_PR
    ? `/${process.env.HOSTED_PR.replace(/^\//, '')}`
    : '';

  return hostedPr + (process.env.PROJECT_BASEPATH ?? '');
};
